import styled from 'styled-components';

export const NavList = styled.ul`
display: flex;
gap: 20px;
list-style: none;
margin: 20px;
padding: 0;
`

export const NavItem = styled.li`
font-size: 18px;
font-weight: 700;
`